import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router'

import { setCustomer } from '../redux/customerSlice'
import request from '../request'
import { selectSession } from '../store'

export default function AuthRoute({ exact, path, component, render }: { exact?: boolean; path?: string | string[]; component?: any; render?: () => JSX.Element | null }) {
  const { authToken, userType, phoneCharacteristics } = useSelector(selectSession)
  const dispatch = useDispatch()

  const getCustomer = () => request(`/customer?phone_model=${phoneCharacteristics.phoneModel}&app_version=${phoneCharacteristics.appVersion}`).then((r) => dispatch(setCustomer(r)))

  useEffect(() => {
    if (authToken && userType) {
      if (userType === 'customer') {
        getCustomer()
      }
    }
  }, [authToken, userType])

  if (!userType && userType !== '') return null

  return <Route exact={exact} path={path} component={component} render={render} />
}
